<div data-cy="overspent-dialog-container" class="overspent-dialog-container">
  <p>
    The FSA Plan included is overspent. <br> This will result in a notice of FSA ineligibility letter being sent.
  </p>
</div>
<div class="overspent-dialog-footer">
  <button data-cy="dialog-no" mat-flat-button class="mat-secondary" (click)="confirmProceed(false)">Go Back</button>
  <button data-cy="dialog-yes" mat-flat-button class="mat-primary ml-4" (click)="confirmProceed(true)">Proceed</button>
</div>
